export default "__VITE_ASSET__B_fe8Zy2__"